import ResponseBussinesRules
  from '../event-handlers/response-bussines-rules-events'

export default new class BusinessRuleResponseHandler {

  /**
   *
   * @param response
   * @param router
   */
  handleResponse (response, router) {
    if (!response.hasOwnProperty('data')) {
      throw new Error('Responsee has not data attribute!')
    }

    if (response.data.hasOwnProperty('values') &&
      response.data.values.hasOwnProperty(ResponseBussinesRules.apiRedirect)) {
      this._processRedirect(
        response.data.values[ResponseBussinesRules.apiRedirect], router)
    }
  }

  /**
   *
   * @param apiRedirectValue
   * @param router
   * @private
   */
  _processRedirect (apiRedirectValue, router) {
    switch (apiRedirectValue) {
      case 1: {
        router.push({ name: 'Dashboard' })
        break
      }
      case 2: {
        console.warn('Maybe redirect to some entity?')
        break
      }
      case 3: {
        // window.location.href = ''
        console.warn('Maybe redirect to some url?')
        break
      }
      default: {
        throw new Error('Redirect statement not implemented!')
      }
    }
  }

}
